//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "HomeTool",
  components: {},
  props: ["tourist-active"],
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      loading: false,
      list: []
    };
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {
    this.fetchList();
  },
  destroyed: function destroyed() {},
  methods: {
    fetchList: function fetchList() {
      var _this = this;

      this.loading = true;
      this.$http.post("/tool/toolPermitList", this.$qs.stringify({
        pageNum: 1,
        pageSize: 100
      })).then(function (_ref) {
        var data = _ref.data;

        if (data.resCode == 0) {
          _this.list = data.resData.list;
        }

        _this.loading = false;
      }).catch(function () {
        _this.loading = false;
      });
    }
  },
  watch: {
    touristActive: function touristActive() {
      this.fetchList();
    }
  },
  filters: {}
};